import request from "@/utils/request";

// 上传图片
function uploadImage(data){
    return request({
        url:'/upload-image',
        data:data,
        method:'post',
        headers: { "Content-Type": "multipart/form-data" }
    })
    // return Promise.resolve({data: 'https://cdn.brightstonecloud.com/qms/1684314892793_ccf6b982-23a1-4a2a-b303-4706adbda410.png', err_code: 0, err_msg: 'OK'})
}

// 获取七牛云私有空间的上传凭证
function getQiniuPrivateUploadToken(data){
    return request({
        url:'/team/getQiniuPrivateUploadToken',
        data:data,
        method:'get',
        headers: { "Content-Type": "multipart/form-data" }
    })
}
// 查询当前时间是否可以报名，提交作品
function getTimeStatus(data){
    return request({
        url:'/getTimeStatus',
        data:data,
        method:'get'
    })
}
// 获取所有配置项
function getAllsettings(data){
    return request({
        url:'/getAllSettings',
        data:data,
        method:'get'
    })
}
export {
    uploadImage,
    getQiniuPrivateUploadToken,
    getTimeStatus,
    getAllsettings
}
